import { render, staticRenderFns } from "./jryw.vue?vue&type=template&id=66634bc0&scoped=true&"
import script from "./jryw.vue?vue&type=script&lang=js&"
export * from "./jryw.vue?vue&type=script&lang=js&"
import style0 from "./jryw.vue?vue&type=style&index=0&id=66634bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66634bc0",
  null
  
)

export default component.exports